import * as React from 'react';
import {connect} from 'react-redux';
import { find as _find } from 'lodash';
import { GlobalPrivateState } from 'src/api';
import { Route, Switch, Redirect } from 'react-router';
import ConfigurationPage from './Configuration/Configuration.page';
import ThankYouPage from '../ThankYou/ThankYou.page';
import { ConfigurationListPage } from './Configuration/ConfigurationList/ConfigurationList.page';
import { AdminPage } from './Admin/Admin.page';
import { userIsAdmin, userIsExternal } from 'src/app/Partials/Admin/utils';
import { FolderListPage } from './Groups/FolderList/FolderList.page';
import { FolderPage } from './Groups/FolderPage';

export interface DashboardProps {
  user: GlobalPrivateState['user'];
}

class DashboardPageComponent extends React.Component<DashboardProps> {

  public render() {
    const user = this.props.user.result;
    const isUserAdmin = user && userIsAdmin(user);
    const isExternal = userIsExternal(user);

    return (
      <div className="page-dashboard">
        <Switch>
          {isUserAdmin && (
            <>
              <Route path="/postcodes" exact={true} component={AdminPage} />
              <Route path="/pricings-accessories/:pricingId" exact={false} component={AdminPage} />
              <Route path="/pricings-washbasin/:pricingId" exact={false} component={AdminPage} />
              <Route path="/pricings-market/:pricingId" exact={false} component={AdminPage} />
              <Route path="/pricings" exact={true} component={AdminPage} />
              <Route path="/" exact={true} component={AdminPage} />  {/* Less specific route at the end */}
            </>
          )}
          {!isUserAdmin && (
            <Route path="/" exact={true} component={ConfigurationListPage} />
          )}
          <Route path="/thank-you" exact={true} component={ThankYouPage} />
          <Route path="/configuration/:configurationId" exact={false} component={ConfigurationPage} />
          <Route path="/configuration" exact={true} render={() => (
            <Redirect to="/" />
          )}/>
          {!isExternal && (
            <>
              <Route path="/folders/:folderId" exact={false} component={FolderPage} />
              <Route path="/folders" exact={true} component={FolderListPage} />
            </>
          )}
        </Switch>
      </div>
    );
  }
}

export const DashboardPage = connect((state: GlobalPrivateState) => ({
  user: state.user,
}))(DashboardPageComponent);

export default DashboardPage;